import { Reveal, RevealGroup, RevealItem } from "@/lib/motion";
import { Section, SectionHeading, GlassCard } from "./primitives";
import { PRINCIPLES, WHY_XVPR } from "@/config/site";

export default function AboutSection() {
  return (
    <Section id="about">
      <SectionHeading
        eyebrow="Manifesto"
        title="Built Around Principles, Not Hype"
        lead="Xenovia Prime is engineered as a fixed-supply digital asset for a growing Web3 ecosystem — designed for longevity over noise."
      />

      {/* Principles — numbered manifesto chapters */}
      <RevealGroup className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/[0.04] sm:grid-cols-2 lg:grid-cols-3">
        {PRINCIPLES.map((p) => (
          <RevealItem
            key={p.n}
            className="group relative bg-[#050508]/60 p-7 transition-colors duration-500 hover:bg-white/[0.03] sm:p-8"
            data-testid={`principle-${p.n}`}
          >
            <div className="font-mono text-[11px] tracking-[0.2em] text-indigo-400">{p.n}</div>
            <h3 className="mt-5 font-display text-lg font-bold uppercase tracking-tight text-white">
              {p.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-gray-400">{p.body}</p>
            <span className="absolute bottom-0 left-0 h-px w-0 bg-gradient-to-r from-indigo-500 to-violet-500 transition-all duration-500 group-hover:w-full" />
          </RevealItem>
        ))}
      </RevealGroup>

      {/* Why XVPR */}
      <div className="mt-28">
        <SectionHeading
          eyebrow="The Problem"
          title="Why XVPR?"
          lead="The challenges the project is designed to address."
        />
        <RevealGroup className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-5">
          {WHY_XVPR.map((w, i) => (
            <RevealItem key={w.title} data-testid={`why-xvpr-${i}`}>
              <GlassCard className="h-full p-6">
                <div className="font-mono text-[11px] tracking-[0.2em] text-violet-300">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="mt-4 font-display text-sm font-bold uppercase leading-tight tracking-tight text-white">
                  {w.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-gray-400">{w.body}</p>
              </GlassCard>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </Section>
  );
}
